export default __webpack_public_path__ + "static/media/027-kiosk.3ee9dcec.svg";